<template>
  <v-chip :class="classModifier">{{ type }}</v-chip>
</template>

<script>
export default {
  props: ['type', 'colors'],
  computed: {
    classModifier() {
      return `hvh-chip hvh-chip--${this.colors[this.type.toLowerCase()] || 'default'}`;
    },
  },
};
</script>

<style lang='scss'>
.theme--light.hvh-chip {
  color: $color-white;
  background: $color-gray-3;
  font-weight: 600;
  font-size: rem(16px);

  &.hvh-chip--teal {
    background: $color-light-blue;
  }

  &.hvh-chip--blue {
    background: $color-blue;
  }

  &.hvh-chip--orange {
    background: $color-orange;
  }

  &.hvh-chip--red {
    background: $color-red;
  }

  &.hvh-chip--green {
    background: $color-green;
  }

  &.hvh-chip--darkBlue {
    background: $color-dark-blue;
  }
}
</style>
